import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
export default class PriceOption extends Component {
  loading = false;
  actor = app?.session?.user;
  oninit(vnode) {
    super.oninit(vnode);
    this.price = this.attrs.price;
    this.product = this.attrs.product;
    this.for = this.attrs.for;
  }
  view() {
    return m("div", {
      className: "PriceOption",
      style: this.for?.color() ? {
        backgroundColor: this.for.color()
      } : ''
    }, m("h2", {
      className: "group"
    }, this.price.cost), m("div", {
      className: "description"
    }, this.recurring()), m("div", {
      className: "controls"
    }, this.button()));
  }
  recurring() {
    if (this.price.type === 'one_time') {
      return 'once';
    } else if (this.price.type === 'recurring') {
      let str = ['every'];
      let interval = this.price.recurring.interval;
      if (this.price.recurring.interval_count > 1) {
        str.push(String(this.price.recurring.interval_count));
        interval += 's';
      }
      str.push(interval);
      return str.join(' ');
    }

    // @TODO: dead code?
    // @ts-ignore
    console.error('Unknown error for interval', this.error);
    return 'no interval known';
  }
  button() {
    if (!this.actor) {
      return m(Button, {
        className: "Button",
        onclick: () => app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
      }, app.translator.trans('core.forum.header.log_in_link'));
    }
    return Button.component({
      icon: 'fas fa-shopping-cart',
      className: 'Button',
      onclick: this.request.bind(this),
      disabled: this.loading
    }, app.translator.trans('floxum-payments.forum.access-portal.purchase'));
  }
  request() {
    const handler = new Handler('pta', {
      price: this.price.id,
      product: this.product.id
    });
    this.loading = true;
    handler.checkout();
  }
}
flarum.reg.add('floxum-payments', 'forum/Groups/PriceOption', PriceOption);